import { useToastContext } from "@/src/components/Toast/ToastProvider";
import { Body8 } from "@/src/components/typography/components/Body";
import React from "react";

import type { ReactNode } from "react";

const RedemptionToastBody = ({ content }: { content: ReactNode }) => (
  <Body8>{content}</Body8>
);

export const useRedemptionToast = () => {
  const { createToast } = useToastContext();

  return (isSuccessful: boolean, content: string) => {
    createToast({
      ToastComponent: <RedemptionToastBody content={content} />,
      theme: "dark",
      type: isSuccessful ? "success" : "error",
      autoClose: false,
    });
  };
};
